import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getViewDataAction } from '../actions';

const {
  useLoaderData: useSessionViewLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getViewDataAction,
});

function SessionViewLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { SessionViewLoader, useSessionViewLoaderData };
